import React from "react";

export const QuestionOne = () => {
  return (
    <div>
      <h1 className="questions-main-heading">Rate our product, based on:</h1>
    </div>
  );
};
